import { computed, type Ref } from 'vue'
import type { ProofOfPlayMetricsResponse, ProofOfPlayTimeRangePreset } from '@/helpers/api/metrics'

export function useCumulativePlayChart(
  proofOfPlayResponse: Ref<ProofOfPlayMetricsResponse | null>,
  timeRange: Ref<ProofOfPlayTimeRangePreset>
) {
  function shortBucketLabel(iso: string): string {
    try {
      const d = new Date(iso)
      const range = timeRange.value
      if (['1min', '1h', '12h', '24h', 'today', 'yesterday'].includes(range)) {
        return d.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'UTC',
        })
      }
      return d.toLocaleDateString([], {
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
      })
    } catch (_e) {
      return iso
    }
  }

  const cumulativeData = computed(() => {
    if (!proofOfPlayResponse.value) return []
    let running = 0
    return proofOfPlayResponse.value.timeSeries.map((b) => {
      running += b.total_plays
      return { bucket: b.bucket, plays: b.total_plays, cumulative: running }
    })
  })

  const cumulativeMax = computed(() => {
    const d = cumulativeData.value
    return d.length ? d[d.length - 1].cumulative : 0
  })

  return {
    shortBucketLabel,
    cumulativeData,
    cumulativeMax,
  }
}
